var $03bcc7d2d97e2965$export$f69c19e57285b83a;
(function(Message) {
    Message["AudioFrame"] = "AUDIO_FRAME";
    Message["SpeechStart"] = "SPEECH_START";
    Message["VADMisfire"] = "VAD_MISFIRE";
    Message["SpeechEnd"] = "SPEECH_END";
    Message["SpeechStop"] = "SPEECH_STOP";
})($03bcc7d2d97e2965$export$f69c19e57285b83a || ($03bcc7d2d97e2965$export$f69c19e57285b83a = {}));


class $933678cb74a101a3$export$fdc6058742272a73 {
    options;
    inputBuffer;
    constructor(options){
        this.options = options;
        this.process = (audioFrame)=>{
            const outputFrames = [];
            for (const sample of audioFrame){
                this.inputBuffer.push(sample);
                while(this.hasEnoughDataForFrame()){
                    const outputFrame = this.generateOutputFrame();
                    outputFrames.push(outputFrame);
                }
            }
            return outputFrames;
        };
        if (options.nativeSampleRate < 16000) console.error("nativeSampleRate is too low. Should have 16000 = targetSampleRate <= nativeSampleRate");
        this.inputBuffer = [];
    }
    process;
    hasEnoughDataForFrame() {
        return this.inputBuffer.length * this.options.targetSampleRate / this.options.nativeSampleRate >= this.options.targetFrameSize;
    }
    generateOutputFrame() {
        const outputFrame = new Float32Array(this.options.targetFrameSize);
        let outputIndex = 0;
        let inputIndex = 0;
        while(outputIndex < this.options.targetFrameSize){
            let sum = 0;
            let num = 0;
            while(inputIndex < Math.min(this.inputBuffer.length, (outputIndex + 1) * this.options.nativeSampleRate / this.options.targetSampleRate)){
                const value = this.inputBuffer[inputIndex];
                if (value !== undefined) {
                    sum += value;
                    num++;
                }
                inputIndex++;
            }
            outputFrame[outputIndex] = sum / num;
            outputIndex++;
        }
        this.inputBuffer = this.inputBuffer.slice(inputIndex);
        return outputFrame;
    }
}


class $ee5cbd4fe799c532$var$Processor extends AudioWorkletProcessor {
    resampler = null;
    _initialized = false;
    _stopProcessing = false;
    options;
    constructor(options){
        super();
        this.options = options.processorOptions;
        this.port.onmessage = (ev)=>{
            if (ev.data.message === (0, $03bcc7d2d97e2965$export$f69c19e57285b83a).SpeechStop) this._stopProcessing = true;
        };
        this.init();
    }
    init = async ()=>{
        this.resampler = new (0, $933678cb74a101a3$export$fdc6058742272a73)({
            nativeSampleRate: sampleRate,
            targetSampleRate: 16000,
            targetFrameSize: this.options.frameSamples
        });
        this._initialized = true;
    };
    process(inputs) {
        if (this._stopProcessing || !this.resampler) return false;
        const arr = inputs[0][0];
        if (this._initialized && arr instanceof Float32Array) {
            const frames = this.resampler.process(arr);
            for (const frame of frames)this.port.postMessage({
                message: (0, $03bcc7d2d97e2965$export$f69c19e57285b83a).AudioFrame,
                data: frame.buffer
            }, [
                frame.buffer
            ]);
        }
        return true;
    }
}
registerProcessor("vad-helper-worklet", $ee5cbd4fe799c532$var$Processor);


//# sourceMappingURL=worklet.js.map
